export default __webpack_public_path__ + "static/media/app-mockup.09b2c31e.png";